/**
 * How much MCP tool access a task grants up front.
 *
 * The composer chooses this before a task exists, so it lives here rather than
 * beside the task API types.
 */
export type McpPermissionMode = 'default' | 'allow_all'

export const DEFAULT_MCP_PERMISSION_MODE: McpPermissionMode = 'default'
